import { render, staticRenderFns } from "./FarmController.vue?vue&type=template&id=0cd42ca4&"
import script from "./FarmController.vue?vue&type=script&lang=ts&"
export * from "./FarmController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports